<template><section><template>
<h3>文件上传</h3>
<div class="bs-docs-section">
<div class="bs-example">
<h4>单个文件上传</h4>
<p><n3-uploader url="http://test.com/" :multiple="false" @error="onError" :max-size="0.5"></n3-uploader></p>
<hr>
<h4>点击上传</h4>
<p><n3-uploader url="http://test.com/" @error="onError"></n3-uploader></p>
<hr>
<h4>支持拖拽</h4>
<p><n3-uploader type="drag" url="http://test.com/" @error="onError"></n3-uploader></p>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-comment">&lt;!-- 单个上传 --&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-uploader</span> <span class="hljs-attr">url</span>=<span class="hljs-string">"http://test.com/"</span> <span class="hljs-attr">:multiple</span>=<span class="hljs-string">"false"</span> <span class="hljs-attr">@error</span>=<span class="hljs-string">"onError"</span> <span class="hljs-attr">:max-size</span>=<span class="hljs-string">"0.5"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-uploader</span>&gt;</span>

<span class="hljs-comment">&lt;!-- 点击上传 --&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-uploader</span> <span class="hljs-attr">url</span>=<span class="hljs-string">"http://test.com/"</span> <span class="hljs-attr">@error</span>=<span class="hljs-string">"onError"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-uploader</span>&gt;</span>

<span class="hljs-comment">&lt;!-- 拖拽上传 --&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-uploader</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"drag"</span> <span class="hljs-attr">url</span>=<span class="hljs-string">"http://test.com/"</span> <span class="hljs-attr">@error</span>=<span class="hljs-string">"onError"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-uploader</span>&gt;</span>
</code></pre>
<h3>参数</h3>
<table>
<thead>
<tr>
<th>参数名</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>name</td>
<td><code v-pre="">String</code></td>
<td>files</td>
<td>文件对象的name</td>
</tr>
<tr>
<td>type</td>
<td><code v-pre="">String</code>：<code v-pre="">click</code> 或 <code v-pre="">drag</code></td>
<td>click</td>
<td>拖拽或者点击</td>
</tr>
<tr>
<td>accept</td>
<td><code v-pre="">String</code></td>
<td>'' (全支持)</td>
<td>支持的文件类型 例如: <code v-pre="">'image/jpeg'</code> 或者 <code v-pre="">'image'</code>支持所有图片格式,多个如 <code v-pre="">'txt|image|mp3'</code></td>
</tr>
<tr>
<td>url</td>
<td><code v-pre="">String</code></td>
<td></td>
<td>上传地址</td>
</tr>
<tr>
<td>params</td>
<td><code v-pre="">Object</code></td>
<td></td>
<td>上传参数</td>
</tr>
<tr>
<td>multiple</td>
<td><code v-pre="">Boolean</code></td>
<td>true</td>
<td>支持多文件上传</td>
</tr>
<tr>
<td>drag-width</td>
<td><code v-pre="">String</code></td>
<td>300px</td>
<td>拖拽框宽度</td>
</tr>
<tr>
<td>drag-height</td>
<td><code v-pre="">String</code></td>
<td>200px</td>
<td>拖拽框高度</td>
</tr>
<tr>
<td>max-length</td>
<td><code v-pre="">Number</code></td>
<td>10</td>
<td>上传文件个数限制</td>
</tr>
<tr>
<td>with-credentials</td>
<td><code v-pre="">Boolean</code></td>
<td>false</td>
<td>跨域时带cookies</td>
</tr>
<tr>
<td>max-size</td>
<td><code v-pre="">Number</code></td>
<td>10</td>
<td>单个文件的size限制（MB）</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>事件名称</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>success</td>
<td>成功上传回调时</td>
<td>({response, file})</td>
</tr>
<tr>
<td>finish</td>
<td>完成所有上传任务时</td>
<td>()</td>
</tr>
<tr>
<td>delete</td>
<td>删除一个上传的项目时</td>
<td>(uploadItem)</td>
</tr>
<tr>
<td>error</td>
<td>发生错误时</td>
<td>({message, file})</td>
</tr>
</tbody>
</table>
</div>
</template>

</section></template>

<script>

export default {
  data () {
    return {
    }
  },
  methods: {
    onError ({ message, file }) {
      console.error(message, file)
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3UploaderDocs.md?37c4f499